var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contactus-processing-banner"},[_c('div',{staticClass:"backdrop LightestColourBackground"}),_c('div',{staticClass:"content text-center LightestColourBackground borderAccent paddedCellL"},[_c('h3',[_vm._v("Sending")]),_c('Loading',{attrs:{"loading":true,"hideLabel":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }